import React from "react";

import { Panel } from "../AdminAnalyticsCards";
import {
  asArray,
  asNumber,
  aa,
  formatNumber,
} from "../adminAnalyticsUtils";

function ChartBar({ label, value, maxValue, sublabel, formatter = formatNumber }) {
  const numericValue = asNumber(value);
  const width =
    maxValue > 0 ? Math.max(4, Math.round((numericValue / maxValue) * 100)) : 0;

  return (
    <div className="admin-analytics-bar-row">
      <div className="admin-analytics-bar-row__header">
        <span>{label}</span>
        <strong>{formatter(numericValue)}</strong>
      </div>
      {sublabel ? (
        <div className="admin-analytics-bar-row__sub">{sublabel}</div>
      ) : null}
      <div className="admin-analytics-bar-track" aria-hidden="true">
        <div
          className="admin-analytics-bar-fill"
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}

export default function CssBarChart({
  title,
  rows,
  value,
  getLabel,
  getValue,
  getSublabel,
  formatter = formatNumber,
  emptyMessage = aa("no_data_for_period", "No data for this period."),
  className = "",
}) {
  const safeRows = asArray(rows);
  const values = safeRows.map((row) => asNumber(getValue(row)));
  const maxValue = values.reduce((max, rowValue) => Math.max(max, rowValue), 0);

  return (
    <Panel title={title} value={value} className={className}>
      {safeRows.length > 0 ? (
        <div className="admin-analytics-bars">
          {safeRows.map((row, index) => (
            <ChartBar
              key={`${title}-${index}-${getLabel(row)}`}
              label={getLabel(row)}
              value={values[index]}
              maxValue={maxValue}
              sublabel={getSublabel ? getSublabel(row) : ""}
              formatter={formatter}
            />
          ))}
        </div>
      ) : (
        <p className="admin-analytics-panel__empty">{emptyMessage}</p>
      )}
    </Panel>
  );
}

export { ChartBar };
